import { Field } from '@smartsoftware/reflex-core';
import { DexResourceModel } from '../abstracts/dexResource.model';

export class VendorMigrationMeta extends DexResourceModel {

    @Field(String)
    public vendor_uuid: string | null = '';
    @Field(Number)
    public last_skip: number | null = 0;
    @Field(Date)
    public min_order_date: Date | null = new Date();
    @Field(String)
    public job_type: string | null = '';
    @Field(String)
    public job_status: string | null = '';
    @Field(Date)
    public max_order_date: Date | null = new Date();
    @Field(Date)
    public last_update: Date | null = new Date();
    @Field(String)
    public sync_type: string | null = '';
    @Field(Number)
    public check_back_days: number | null = 0;
    @Field(Boolean)
    public is_out_of_sync: boolean = false;
    @Field(Boolean)
    public is_in_resync: boolean = false;
    @Field(String)
    public vendor_differentiator: string = '';

    constructor(data?: any) {
        super();
        this.mapData(data);
    }

    public get lastUpdateUTC(): Date | null{
        if(!this.last_update) return null;
        return this.pacificDateAsUTC(this.last_update);
    }

}
